import { useContext } from "react";
import { useCreateAdventure, useUpdateAdventure } from "../../api/mutations/adventureMutations";
import { useCreateDestination, useUpdateImages, useUpdateDestination } from "../../api/mutations/destinationMutations";
import { createFormConfig, FormTypes } from "../../utils/formFactory";
import CustomForm from "./customForm.component";
import { FormContext } from "../../context/form.context";
import { useCreateProgramme } from "../../api/mutations/programmeMutations";


const DynamicForm = ({ formType, title, initialValues = {} }) => {  
  const { fields, groupedFields = [] } = createFormConfig(formType);
  const { formData, setInitialFormdata } = useContext(FormContext); 
  console.log(initialValues)
  Object.entries(formData).length === 0 && setInitialFormdata(formType, initialValues);

  try {
    const onSubmit = (() => {
      switch (formType) {
        case FormTypes.Destination:
          return useCreateDestination;
        case FormTypes.UpdateDestination:
          return useUpdateDestination;
        case FormTypes.UpdateAdventure:
          return useUpdateAdventure;
        case FormTypes.Adventure:
          return useCreateAdventure;
        case FormTypes.DestinationImage:
          return useUpdateImages;

        case FormTypes.Programme:
          return useCreateProgramme;
        default:
          throw new Error("not implemented");
      }
    })();
    
    return (
      <div className="dynamic-form">
        <h1>{title}</h1>
        <CustomForm fields={fields} groupedFields={groupedFields} onSubmit={onSubmit()} />
      </div>
    );
  } catch (error) {
    return <p>Error: {error.message}</p>;
  }
};

export default DynamicForm;
